const namespace = 'BOOKING/EXTRAS/';

export const GET_EXTRAS = namespace + 'GET_EXTRAS';
export const SET_EXTRAS = namespace + 'SET_EXTRAS';
